import { SVGProps } from "react";

const CardHero1DesktopUnderline = ({
  className,
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 382 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M10.0009 16C148.983 0.638318 183.459 20.7675 372.001 11.33"
        stroke="#CFB2FF"
        strokeWidth="20"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CardHero1DesktopUnderline;
